import useReportsFilterText from '@app/hooks/useReportsFilterText';
import useRootSelector from '@app/hooks/useRootSelector';
import {
  IEndOfShiftReport,
  usersSelectionValuesFactory,
} from '@westondev/tableturn-core';
import { useCallback, useMemo, useState } from 'react';
import { WithTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreatorsReports } from '@westondev/tableturn-core';
import UsersSelectionModal from '@app/components/common/SelectionModal/UsersSelectionModal';
import { IItemSelection } from '@app/components/common/SelectionModal/GenericSelectionModal/types';
import Dropdown from '@app/components/common/Dropdown';

const handleReportsChange = actionCreatorsReports.handleReportsChange;

const EndOfShiftReportOwnerFilter = ({ t }: WithTranslation) => {
  const setValues = bindActionCreators(handleReportsChange, useDispatch());
  const ownerIds = useRootSelector(
    state => (state.reports.changeData?.data as IEndOfShiftReport)?.ownerIds,
  );
  const currentUsers = useRootSelector(state => state.settings.master.users);

  const [isModalActive, setIsModalActive] = useState(false);

  const userOptions = useMemo(() => {
    return usersSelectionValuesFactory(currentUsers);
  }, [currentUsers]);

  const ownerIdsValueText = useReportsFilterText('ownerIds', ownerIds);

  const handleOnChangeDone = useCallback(
    (selectedOwnerOptions: IItemSelection[]) => {
      if (!selectedOwnerOptions?.length) {
        setValues(prev => ({ ...prev, ownerIds: null }));
        return;
      }

      const selectedOwnerIds = selectedOwnerOptions.map(v => Number(v.id));

      setValues(prev => ({
        ...prev,
        ownerIds: selectedOwnerIds,
      }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const selectedButtonIds = useMemo(() => {
    if (!ownerIds?.length) return [];

    return ownerIds.map(id => {
      const user = currentUsers[id];
      return user?.organizationUserId || 0;
    });
  }, [ownerIds, currentUsers]);

  return (
    <>
      <UsersSelectionModal
        buttons={userOptions}
        selectedButtonIds={selectedButtonIds}
        onAssociate={selectedButtons => {
          handleOnChangeDone(selectedButtons);
          setIsModalActive(false);
        }}
        onModalClose={() => {
          setIsModalActive(false);
        }}
        active={isModalActive}
        allowAssociateMultiple
        showDescriptionPanel={false}
        associateOnSelect={false}
        showSelectedButtons
        showSelectAll
      />
      <Dropdown
        data={[]}
        onChange={() => null}
        placeholder={ownerIdsValueText}
        label={t('reports.fields.ownerIds')}
        customText={ownerIdsValueText}
        onActive={() => setIsModalActive(true)}
        isEditable={false}
      />
    </>
  );
};

export default EndOfShiftReportOwnerFilter;
